<template>
  <!-- te-popup begin -->
  <div class="te-alert d-flex flex-column">
    <a
      v-if="!hideClose"
      href="javascript:void(0)"
      class="close"
      style="z-index: 10;"
      @click="$emit('close')"
    >
      <i class="material-icons">close</i>
    </a>
    <div class="content d-flex align-items-center flex-column flex-grow-1">
      <slot />
    </div>
    <div class="alert-btn">
      <button
        v-if="!hideCancel"
        class="mx-1 btn btn-sm btn-light rounded"
        @click="$emit('cancel')"
      >
        <span class="px-3">{{ textOfCancel }}</span>
      </button>
      <button
        v-if="!hideConfirm"
        class="mx-1 btn btn-sm btn-primary rounded"
        :disabled="disabledConfirm"
        @click="$emit('confirm')"
      >
        <span class="px-3">{{ textOfOK }}</span>
      </button>
    </div>
  </div>
  <!-- te-popup end -->
  <!-- <b-modal
    v-model="showPopup"
    hide-footer
    hide-header
    :centered="centered"
    no-close-on-backdrop
    size="sm"
  >
    <button type="button" aria-label="Close" class="close" @click="close" v-if="haveClose">×</button>
    <div class="d-block text-center mb-4 font-size-md">
      <h5 class="mb-3" v-html="title"></h5>
      <p v-html="content"></p>
      <slot />
    </div>
    <b-button class="mt-3" block variant="primary" pill @click="ok" v-if="haveOK">{{textOfOK}}</b-button>
    <a href="javascript:void(0)" @click="cancel" v-if="haveCancel" class="d-block text-center p-1 mt-1 font-size-sm">{{textOfCancel}}</a>

  </b-modal> -->
</template>

<script>
export default {
  model: {
    prop: 'showPopup',
    event: 'setShowPopup'
  },
  props: {
    disabledConfirm: {
      type: Boolean,
      default: false
    },
    hideConfirm: {
      type: Boolean,
      default: false
    },
    hideCancel: {
      type: Boolean,
      default: false
    },
    hideClose: {
      type: Boolean,
      default: false
    },
    textOfOK: {
      type: String
    },
    textOfCancel: {
      type: String
    }
  },
  methods: {
    ok() {
      this.$emit('setShowPopup', false);
      this.$emit('ok');
    },
    cancel() {
      this.$emit('setShowPopup', false);
      this.$emit('cancel');
    },
    close() {
      this.$emit('setShowPopup', false);
      this.$emit('close');
    }
  }
};
</script>
